import { render, staticRenderFns } from "./CustomLabelFreshBandType3.vue?vue&type=template&id=6e0a3538&scoped=true&"
import script from "./CustomLabelFreshBandType3.vue?vue&type=script&lang=js&"
export * from "./CustomLabelFreshBandType3.vue?vue&type=script&lang=js&"
import style0 from "./CustomLabelFreshBandType3.vue?vue&type=style&index=0&id=6e0a3538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0a3538",
  null
  
)

export default component.exports